//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Divider, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponseMessages } from "../../../types/common";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";
import moment from "moment";

//-------------------------------------------------------------------------------------------------- Interface
interface NotificationDescriptionProps {
    notification: ResponseMessages;
};

//-------------------------------------------------------------------------------------------------- Component
const NotificationDescription = (props: NotificationDescriptionProps) => {
    const { notification } = props;

    return (
        <Row style={styles.mainContainer}>
            <Col sm={20} md={16} xl={12}>
                <Card style={styles.cardStyle}>
                    <Row>
                        <Col span={24}>
                            <h2 style={styles.dateStyle}>
                                {moment(notification.date).format("DD MMMM YYYY - H:mm")}
                            </h2>
                        </Col>
                        <Col span={24}>
                            <h3 style={styles.textStyle}>
                                {notification.title}
                            </h3>
                        </Col>
                    </Row>
                    <Divider />
                    <Row>
                        <Col span={24}>
                            <MarkdownPreviewer
                                h1Style={{ ...styles.titleStyle, ...{ fontSize: 16, color: "#000000" } }}
                                h2Style={styles.titleStyle}
                                h3Style={styles.titleStyle}
                                textStyle={styles.textStyle}
                                mdSource={notification.message}
                            />
                        </Col>
                        {
                            notification.imageUrl && (
                                <Col span={24} style={styles.imageContainer}>
                                    <img
                                        style={styles.imageStyle}
                                        src={notification.imageUrl}
                                        alt="imágen de notificación"
                                    />
                                </Col>
                            )
                        }
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        margin: "50px 0px 50px 0px",
        justifyContent: "center",
    },
    cardStyle: {
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
    },
    dateStyle: {
        fontSize: 14,
        color: "#0055b9",
    },
    titleStyle: {
        fontSize: 14,
        margin: 0,
        color: "#707070",
        fontWeight: 500
    },
    textStyle: {
        fontSize: 14,
        margin: 0,
        color: "#707070",
    },
    imageContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "25px 0px 10px 0px",
    },
    imageStyle: {
        borderRadius: 20,
        width: "100%",
    },
});

//--------------------------------------------------------------------------------------------------
export default NotificationDescription;
